import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: 48px;
  margin-bottom: 48px;
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;
  margin-top: 24px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
`;

export const FooterLink = styled.a`
  display: flex;
  align-items: center;
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  color: ${customPalette.accent.main};
  text-decoration: none;
  padding: 12px;
  border-radius: 24px;
  background-color: ${customPalette.accent.white};

  &:hover {
    text-decoration: none;
    background-color: ${customPalette.grey[50]};
  }
`;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  color: ${customPalette.accent.main};
  text-decoration: none;
  padding: 12px;
  border-radius: 24px;
  border: 0;
  background-color: ${customPalette.accent.white};

  &:hover {
    text-decoration: none;
    background-color: ${customPalette.grey[50]};
    cursor: pointer;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-right: 6px;
`;

export const FooterText = styled.p`
  font-size: 12px;
  color: ${customPalette.grey[300]};
  text-align: center;
  margin-top: 24px;
`;

export const Divider = styled.div`
  width: 201px;
  height: 4px;
  background-color: ${customPalette.grey[100]};
  border-radius: 2px;
`;
